const alertMessage = function() {
    // settings
    this.enable             = false,
    this.startDateString    = '12/4/2024';
    this.startDate          = new Date(this.startDateString);
    this.endDateString      = '1/3/2025';
    this.endDate            = new Date(this.endDateString);
    
    // html selectors
    this.cookieName         = 'alertMessage';
    this.identifier         = '#alertMessage';
    this.popupWrapper       = '#alertModal';

    // initilize
    if (this.enable) {
        this.init();
    }
};

alertMessage.prototype.init = function () {
    if ($(this.identifier).length > 0) {
        // start process
        var dateValid = this.checkDateValidity();

        if (!dateValid) {
            return;
        }

        this.initPopup();
    }
}

alertMessage.prototype.checkDateValidity = function () {
    this.todayDate = new Date().getTime();

    if (
        this.todayDate >= this.startDate.getTime() && 
        this.todayDate <= this.endDate.getTime()
    ) {
        return true;
    }

    return false;
}

alertMessage.prototype.initPopup = function () {
    if ($.cookie(this.cookieName) === null) {
        const self = this;

        $.magnificPopup.open({
            mainClass: 'mfp-fade',
            fixedContentPos: true,
            items: {
                src: self.popupWrapper,
                type: 'inline',
            },
            callbacks: {
                open: function () {
                    $(self.popupWrapper).addClass('active');
                },
                close: function () {
                    $.cookie(self.cookieName, true, {path:'/'});
                }
            }
        });
    }
}
